const de = {
  jobOfferingActive: 'Das Stellenangebot ist für Studenten sichtbar.',
  jobOfferingExpired: 'Das Stellenangebot ist abgelaufen.',
  jobOfferingEdited: 'Das Stellenangebot wurde bearbeitet.'
};

export default de;
export type JobOfferingNotificationTranslation = typeof de;
